<template>
  <div>
    <div class="mr-auto">
      <p class="text-uppercase text-dark font-weight-bold mb-1">
        Agenda
      </p>
    </div>
    <div class="air__utils__scrollTable mb-1 mt-2">
      <a-table
        :columns="columns"
        :dataSource="scheduleRows"
        :pagination="false"
        :showHeader="false"
        :scroll="{ x: '100%' }"
      >
        <template slot="date" slot-scope="user">
          <div>
            <div><strong class="text-uppercase text-dark font-weight-bold">{{ user.name }}</strong></div>
            <div class="text-gray-4">{{ user.position }}</div>
          </div>
        </template>
        <template slot="value" slot-scope="value">
          <div class="text-nowrap">
            <p>{{ value | money }}</p>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
/**
 * {
    "key": "3",
    "date": {"name": "Segunda-Feira", "position": "18/11"},
    "value": 33.12
  }

 */
import moment from "moment";
import _ from "lodash";

export default {
  name: "ReceivementSchedule",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data: function() {

    moment.locale('pt-br');

    return {
      moment,
      range: 6,
      columns: [
        {
          title: "Data",
          dataIndex: "date",
          className: "bg-transparent",
          scopedSlots: { customRender: "date" }
        },
        {
          dataIndex: "value",
          className: "bg-transparent text-right",
          scopedSlots: { customRender: "value" }
        }
      ],
      data: []
    };
  },
  computed: {
    scheduleRows() {
      const v = this;

      // faz o select dos dados
      this.data.forEach(row => {
        const itens = _.filter(v.items, function(o) {
          return v.moment(o.dtPayment).isBetween(
            row.date.raw.toISOString(),
            v
              .moment(row.date.raw.toISOString())
              .endOf("day")
              .toISOString(),
            undefined,
            "[]"
          );
        });

        row.value = itens.reduce((acc, cv) => {
          return acc + cv.netAmountTotal;
        }, 0);
      });
      return this.data;
    }
  },
  created() {
    // cria a estrutura de exibicao
    for (let index = 0; index < this.range; index++) {
      const today = this.moment().startOf("day");
      const currentDate = today.add(index, "day");
      this.data.push({
        key: index,
        date: {
          name: currentDate.format("dddd"),
          position: currentDate.format("DD/MM"),
          raw: currentDate
        },
        value: 0
      });
    }
  }
};
</script>
